import React from 'react';
import { CheckCircleOutlined } from '@mui/icons-material';

import { toast } from "react-toastify";

export const showToastInfo = (message, icon) => {
  toast.info(message, {
    icon: icon || <CheckCircleOutlined />,
  });
}

export const showToastSuccess = (message, icon) => {
  toast.success(message, {
    icon: icon || <CheckCircleOutlined />,
  });
}

export const showToastError = (message, icon) => {
  toast.error(message, {
    icon
  })
}
